import { InjectionToken } from '@angular/core';
import { INavMenu } from '@shared/interfaces';

/**
 * @const NAV_MENU
 * Injection token for nav menu data for the application
 */
export const NAV_MENU: InjectionToken<INavMenu> = new InjectionToken('NAV_MENU');
